import gsap from "../../helpers/gsapInstance";
import {MAX_MOBILE_WIDTH} from "../../constans";
import MainPageCommonService from "./MainPageCommonService";
import MainPageFifthScreenMobile from "../../pages/main-page/screens/fifth/MainPageFifthScreenMobile";
import MainPageSecondScreenMobile from "../../pages/main-page/screens/second/MainPageSecondScreenMobile";

type ScreenType = MainPageFifthScreenMobile | MainPageSecondScreenMobile;

export default class MainPageCardsScreensMobileService extends MainPageCommonService {
    public Screen: ScreenType;

    constructor(screen: ScreenType) {
        super();

        this.Screen = screen;

        this.initScreenScrollingAnimations = this.initScreenScrollingAnimations.bind(this);
        this.initSlideTopContentOnScrollingAnimation = this.initSlideTopContentOnScrollingAnimation.bind(this);
        this.initSlideCenterContentOnScrollingAnimation = this.initSlideCenterContentOnScrollingAnimation.bind(this);
        this.initSlideBottomContentCardsOnScrollingAnimation = this.initSlideBottomContentCardsOnScrollingAnimation.bind(this);
        this.initSlideBottomContentLinksOnScrollingAnimation = this.initSlideBottomContentLinksOnScrollingAnimation.bind(this);
    }

    public initScreenScrollingAnimations(): void {
        this.initSlideTopContentOnScrollingAnimation();
        this.initSlideCenterContentOnScrollingAnimation();
        this.initSlideBottomContentCardsOnScrollingAnimation();
        this.initSlideBottomContentLinksOnScrollingAnimation();
    }

    private initSlideTopContentOnScrollingAnimation(): void {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.Screen.$screen,
                start: "top center",
            },
        });

        tl.fromTo(
            this.Screen.$topContent,
            {
                transform: 'translateY(30%)',
                opacity: 0,
            },
            {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 0.6
            },
        )
    }

    private initSlideCenterContentOnScrollingAnimation(): void {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.Screen.$screen,
                start: "top center",
            },
        });

        tl.fromTo(
            this.Screen.$innerCenterPoint,
            {
                transform: 'translate(-50%, 30%)',
                opacity: 0,
            },
            {
                transform: 'translate(-50%, 0)',
                opacity: 1,
                duration: 0.6,
                delay: 0.3
            },
        );
    }

    private initSlideBottomContentCardsOnScrollingAnimation(): void {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.Screen.$screen,
                start: "20% center",
            },
        });

        tl.fromTo(
            this.Screen.$bottomContentCards,
            {
                transform: 'translateY(30%)',
                opacity: 0,
            },
            {
                transform: 'translateY(0)',
                opacity: 1,
                duration: 0.6,
            },
        );
    }

    private initSlideBottomContentLinksOnScrollingAnimation(): void {
        const TABLET_START_OFFSET = 40;
        const MOBILE_START_OFFSET = 50;
        let startOffset = TABLET_START_OFFSET;

        if (window.innerWidth <= MAX_MOBILE_WIDTH) {
            startOffset = MOBILE_START_OFFSET;
        }


        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.Screen.$screen,
                start: `${startOffset}% center`,
            },
        });

        tl.fromTo(
            this.Screen.$bottomContentLinks,
            {
                transform: 'translateY(30%)',
                opacity: 0,
            },
            {
                transform: 'translateY(0)',
                opacity: 1,
                duration: 0.6,
            },
        );
    }
}
